<template>
  <mv-page>
    <v-flex xs1 class="hidden-md-and-down" style="position:fixed; top: 70px">
      <h2 class="font-weight-light">Сообщения</h2>
    </v-flex>
    <mv-med-row>
      <v-layout wrap>
        <v-flex xs12>
          <v-subheader class="pl-0 px-0">
            <v-btn icon small outline color="primary" @click="calendar = !calendar">
              <v-icon small v-if="calendar">view_module</v-icon>
              <v-icon small v-else>view_list</v-icon>
            </v-btn>
            <v-btn icon small flat color="primary" @click="prev">
              <v-icon dark>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-menu offset-y left>
              <div slot="activator" style="display: inline-block; width: 50px"
              class="text-xs-center primary--text"
              >{{month}}</div>
              <v-date-picker
              locale="ru" first-day-of-week="1" type="month"
              v-model="monthPick" :reactive="true" color="#f2c44f">
              </v-date-picker>
            </v-menu>
            <v-btn icon flat color="primary" @click="next">
              <v-icon dark>keyboard_arrow_right</v-icon>
            </v-btn>
            <v-spacer></v-spacer>
          </v-subheader>
        </v-flex>
        <v-flex xs12 v-if="calendar">
          <v-sheet height="480">
            <v-calendar
              v-if="messages"
              locale="ru"
              ref="calendar"
              v-model="start"
              type="month"
              :weekdays="[1, 2, 3, 4, 5, 6, 0]"
              color="red"
              class="text-xs-center"
            >
              <template slot="day" slot-scope="day" v-if="messages[day.date]">
                <v-menu lazy>
                  <v-flex xs12 class="text-xs-center py-0 cursor-pointer"
                   slot="activator"
                  >
                    <mv-msg-count transport="sms" hidenil :count="messages[day.date].sms"></mv-msg-count>
                    <mv-msg-count transport="eml" hidenil :count="messages[day.date].email"></mv-msg-count>
                  </v-flex>
                  <v-sheet class="py-2">
                    <ul class="column-reverse">
                        <li v-for="msg in messages[day.date].msgs" :key="msg.id" class="msgs">
                            <span>{{(msg.transport + '&nbsp;&nbsp;&nbsp;').slice(0, 6)}}</span>
                            &nbsp;
                            <span style="color:grey">{{ getTime(msg.cts) }}</span>
                            &nbsp;
                            {{msg.content.length &lt; 30 ? msg.content : (msg.title || (msg.content.substring(0, 30) + '...'))}}
                        </li>
                    </ul>
                  </v-sheet>
                </v-menu>
              </template>
            </v-calendar>
            <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
          </v-sheet>
          <br /><br />
        </v-flex>
        <v-flex xs12 v-else>
          <v-list v-if="messages" dense two-line @scroll.native="handleScroll">
            <v-subheader v-if="nodata && dates.length === 0">Нет данных за период</v-subheader>
            <template v-for="date in dates">
              <v-subheader class="text-xs-center mt-3" :key="date">
                <v-divider></v-divider>
                &nbsp;{{date}}&nbsp;
                <v-divider></v-divider>
              </v-subheader>
              <v-list-tile avatar v-for="msg in messages[date].msgs" :key="msg.id"
              @click="detailsFor=msg;detailsDialog=true"
              >
                <v-list-tile-avatar class="hidden-xs-only">
                  <v-icon :class="transportClass(msg.transport)">{{transportIcon(msg.transport)}}</v-icon>
                </v-list-tile-avatar>
                <v-list-tile-content>
                  <v-list-tile-title>{{msg.content.length &lt; 30 ? msg.content : (msg.title || (msg.content.substring(0, 30) + '...'))}}</v-list-tile-title>
                  <v-list-tile-sub-title>{{msg.address}}</v-list-tile-sub-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-list-tile-action-text>
                    <span v-if="msg.status === 'ошибка'" class="status-red">{{msg.status}}</span>
                    <span v-else>{{msg.status}}</span>
                  </v-list-tile-action-text>
                  <v-list-tile-action-text>
                    {{getTime(msg.cts)}}
                  </v-list-tile-action-text>
                </v-list-tile-action>
              </v-list-tile>
            </template>
            <div v-observe-visibility="probablyPageBottom"></div>
            <v-dialog
              v-model="detailsDialog"
              :fullscreen="$vuetify.breakpoint.xs"
              scrollable
              :overlay="false"
              max-width="500"
              transition="dialog-transition"
              class="mx-1"
            >
              <v-card v-if="detailsFor" class="pa-0">
                <v-toolbar flat>
                  <span>{{detailsFor.title}}</span>
                  <v-spacer></v-spacer>
                  <b>{{detailsFor.transport}}</b>&nbsp;&nbsp;
                </v-toolbar>
                <v-card-text class="px-3">
                  <p>
                    <b>Сообщение</b>
                    <br />
                    <pre><i>{{detailsFor.content}}</i></pre>
                  </p>
                  <p>
                    <b>Адрес</b>
                    <br />
                    {{detailsFor.address}}
                  </p>
                  <p>
                    <b>Время</b>
                    <br />
                    {{detailsFor.date}} {{getTime(detailsFor.cts)}}
                  </p>
                  <p>
                    <b>Тип подписки</b>
                    <br />
                    {{getSubName(detailsFor.subscription)}}
                  </p>
                </v-card-text>
                <template v-if="$vuetify.breakpoint.xs">
                  <v-divider></v-divider>
                  <v-card-actions @click="detailsDialog = false">
                    <v-btn flat block color="primary" @click="detailsDialog = false">закрыть</v-btn>
                  </v-card-actions>
                </template>
              </v-card>
            </v-dialog>
            <br />
          </v-list>
          <v-progress-linear v-else :indeterminate="true"></v-progress-linear>
          <mv-page-bottom-progress v-show="moreProgress"></mv-page-bottom-progress>
        </v-flex>
      </v-layout>
    </mv-med-row>
  </mv-page>
</template>

<script>
import moment from 'moment'
import debounce from 'debounce'
export default {
  name: 'messages',
  data: () => ({
    start: moment().startOf('month').format('YYYY-MM-DD'),
    messages: null,
    dialog: false,
    calendar: null,
    more: moment().startOf('month').format('YYYY-MM-DD'),
    moreProgress: false,
    moreWasEmptyTimes: 0,
    nodata: false,
    detailsDialog: false,
    detailsFor: null,
    monthPick: moment().startOf('month').format('YYYY-MM')
  }),
  computed: {
    profile () {
      return this.$store.state.profile
    },
    month () {
      return moment(this.start).startOf('month').format('MMMM YYYY')
    },
    dates () {
      if (!this.messages) return []
      return Object.keys(this.messages)
      .filter(x => !['sms', 'email', 'total'].includes(x))
      .sort().reverse()
    }
  },
  methods: {
    async fetch () {
      this.nodata = false
      const { messages } = await this.fetchMessages()
      this.nodata = Object.keys(messages).length === 3
      this.messages = messages
    },
    async fetchMessages (month) {
      return this.$store.dispatch('sioRequest', {
        topic: 'messages-by-month',
        pl: {
          month: month || this.start
        }
      })
    },
    getTime (date) {
      return moment(date).format('HH:mm')
    },
    getSubName (sub) {
      if (sub === 'pass') return 'Уведомления о проходах'
      if (sub === 'lowbalance') return 'Уведомления о низком балансе'
      if (sub === 'purchase') return 'Уведомления о продаже'
      if (sub === 'payment') return 'Уведомления о пополнении'
      if (sub === 'news') return 'Уведомления о публикации новостей'
      return 'Другие информационные сообщения'
    },
    async addMore () {
      this.more = moment(this.more).subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
      const { messages, meta } = await this.fetchMessages(this.more)
      this.messages = Object.assign(messages, this.messages)
      this.moreProgress = false
      if (meta.count < 5 && meta.count !== 0) {
        this.moreProgress = true
        this.syncMore()
      } else {
        if (meta.count === 0 && this.moreWasEmptyTimes < 3 ) {
          this.moreWasEmptyTimes++
          this.moreProgress = true
          this.syncMore()
        } else {
          this.moreWasEmptyTimes = 0
        }
      }
    },
    async updateInterval () {
      this.fetch()
    },
    prev () {
      if (this.calendar) {
        this.$refs.calendar.prev()
      } else {
        this.start = moment(this.start).subtract(1, 'months').startOf('month').format('YYYY-MM-DD')
      }
    },
    next () {
      if (this.calendar) {
        this.$refs.calendar.next()
      } else {
        this.start = moment(this.start).add(1, 'months').startOf('month').format('YYYY-MM-DD')
      }
    },
    transportIcon (transport) {
      if (transport === 'email') return 'alternate_email'
      if (transport === 'sms') return 'phone_android'
      if (transport === 'telegram') return 'telegram'
      return '*'
    },
    transportClass (transport) {
      if (transport === 'sms') return 'blue lighten-2 white--text'
      if (transport === 'email') return 'red lighten-2 white--text'
      if (transport === 'telegram') return 'blue lighten-2 white--text'
      return 'grey lighten-1 white--text'
    },
    probablyPageBottom (isVisible) {
      if (isVisible && this.messages) {
        this.moreProgress = true
        this.syncMore()
      }
    }
  },
  watch: {
    async profile (val) {
      if (val) await this.fetch()
    },
    start (val, old) {
      this.messages = null
      if (typeof val === 'object') {
        this.start = old
      }
      if (this.messages !== undefined) {
        this.more = val
        this.syncStart(val)
      }
    },
    monthPick (val) {
      if (val) this.start = moment(val).startOf('month').format('YYYY-MM-DD')
    },
    calendar (val) {
      if (val !== null) localStorage.setItem('detiMessagesCalendar', val)
    }
  },
  async mounted () {
    if (this.profile) await this.fetch()
  },
  created () {
    this.syncStart = debounce(this.updateInterval, 600)
    this.syncMore = debounce(this.addMore, 1000)
    const calendar = JSON.parse(localStorage.getItem('detiMessagesCalendar'))
    if (calendar === null) {
      this.calendar = false
    } else {
      this.calendar = calendar
    }
  }
}
</script>

<style lang="css">
.cursor-pointer {
  cursor: pointer;
}
.inline-block {
  display: inline-block;
}
.msgs {
  padding: 6px 16px 0 16px;
  font-size: 14px;
}
/* инверсия по горизонтали */
.column-reverse { display: flex; flex-direction: column-reverse; }
.status-red {
  color: crimson
}
</style>
